module.exports = __webpack_public_path__ + "static/media/ideation-sketching.30f55212.jpg";